require('./_mdb-default');

import LazyLoad from 'lazyload';

import { preventDuplicateSubmit, preventDuplicateClick } from './utils/prevent_events';

import { EmptyCss } from './utils/check_css';

function calcContentTop() {
    const headerEl: HTMLElement = document.querySelector('header.siteHeader, section.siteHeader');
    if (headerEl == null) return;
    if (headerEl.classList.contains('noHeaderMargin')) return;
    const navEl: HTMLElement = headerEl.querySelector('nav.fixed-top');
    if (navEl == null) return;

    var calcHeight;
    if (headerEl.classList.contains('fitHeaderMargin')) {
        calcHeight = navEl.getBoundingClientRect().height;
    } else {
        calcHeight = navEl.getBoundingClientRect().height + 16;
    }

    const target_id = 'header-nav-margin';
    var marginEl: HTMLElement = document.getElementById(target_id);
    if (marginEl == null) {
        marginEl = document.createElement('div');
        marginEl.id = target_id;
        headerEl.after(marginEl);
    }
    marginEl.style.marginTop = calcHeight + 'px';
}

function hookScrollFadeIn() {
    var targets = $('.scroll-fadein');
    if (!targets) {
        return;
    }

    window.addEventListener('scroll', function () {
        if ($(this).scrollTop() > 100) {
            targets.fadeIn();
        } else {
            targets.fadeOut();
        }
    });
}

function hookPageTop() {
    var pagetop = $('.pagetop');
    if (!pagetop) {
        return;
    }

    pagetop.on('click', function () {
        $('body, html').animate({ scrollTop: 0 }, 500);
        return false;
    });
}

calcContentTop();

hookScrollFadeIn();
hookPageTop();

(window as any).preventDuplicateSubmit = preventDuplicateSubmit;
(window as any).preventDuplicateClick = preventDuplicateClick;

try {
    const images = document.querySelectorAll('.lazyload');
    new LazyLoad(images);
} catch (e) {}

try {
    const url = new URL(location.href);
    if (url.searchParams.get('check') && url.searchParams.get('check') == 'css') {
        EmptyCss();
    }
} catch (e) {}
